import { Button } from '../Button';
import { Eyebrow } from '../Eyebrow';

const MAILTO =
  'mailto:info@zacharycompanies.com' +
  '?subject=' +
  encodeURIComponent('Custom builders risk indication request') +
  '&body=' +
  encodeURIComponent(
    "Hi Zachary team,\n\nI'd like a custom builders risk indication for a project outside your online pricing states.\n\nProject details:\n- Named insured:\n- Project address:\n- Construction type:\n- Hard / soft costs:\n- Start / end dates:\n\nThanks,\n",
  );

/**
 * Rendered at the bottom of Step 1 when the user picks state=OTHER.
 * Blocks forward progress per PRD §11.1.
 */
export function OtherStatePanel() {
  return (
    <section
      role="status"
      aria-live="polite"
      className="mt-8 relative bg-panel border border-hairline rounded-md p-8 md:p-10 overflow-hidden"
    >
      <div
        aria-hidden="true"
        className="absolute left-0 top-0 bottom-0 w-[3px] bg-gradient-primary"
      />
      <Eyebrow>CUSTOM_INDICATION · STATE_NOT_PRICED</Eyebrow>
      <h2 className="mt-3 font-display font-medium tracking-[-0.01em] leading-tight text-[clamp(22px,2.8vw,30px)] max-w-2xl">
        We don&rsquo;t price this state online yet.
      </h2>
      <p className="mt-4 max-w-xl text-[1rem] leading-relaxed text-ink-muted">
        The Zachary Group writes builders risk nationwide, but our instant indication tool is
        currently limited to Michigan, Georgia, Florida, Texas, and California. Reach out and a
        broker will work up a custom indication within two business days.
      </p>
      <div className="mt-6">
        <Button as="a" href={MAILTO} variant="primary">
          Contact a broker
        </Button>
      </div>
    </section>
  );
}
